import React from "react";
import { DefinitionList } from "components/common";
import DefaultColumnRenderers from "components/common/EntityDataTable/DefaultColumnRenderers";
const EventDetailsDefinitionList = ({
  event,
  attributesList,
  meta = {},
  eventProcedureId = "",
  attributesRenderers
}) => /* @__PURE__ */ React.createElement(DefinitionList, null, attributesList.map((attribute) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const defaultTypeRenderer = (_b = (_a = DefaultColumnRenderers.types) == null ? void 0 : _a[attribute == null ? void 0 : attribute.type]) == null ? void 0 : _b.renderCell;
  const typeRenderer = (_d = (_c = attributesRenderers == null ? void 0 : attributesRenderers.types) == null ? void 0 : _c[attribute == null ? void 0 : attribute.type]) == null ? void 0 : _d.renderCell;
  const renderCell = (_g = (_f = (_e = attributesRenderers[attribute.id]) == null ? void 0 : _e.renderCell) != null ? _f : typeRenderer) != null ? _g : defaultTypeRenderer;
  const value = event[attribute.id];
  return /* @__PURE__ */ React.createElement(React.Fragment, { key: attribute.id }, /* @__PURE__ */ React.createElement("dt", null, attribute.title), /* @__PURE__ */ React.createElement("dd", null, renderCell ? renderCell(value, event, meta, eventProcedureId) : value));
}));
export default EventDetailsDefinitionList;
